export default {
  status: {
    message: null,
    type: null
  }
};
